import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  constructor(private readonly keycloak: KeycloakService, private readonly router: Router) {}

  public ngOnInit() {
    this.keycloak.isLoggedIn().then(data => {
      if(data){
        this.router.navigate(["/home"]);
      }
    })
  }
}
